/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Precheck_IgnoreInputs */



/**
* | output |
* | --- |
* | "Ignore" |
*
* @param {Video_Export_Precheck_IgnoreInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_precheck_ignore = /** @type {((inputs?: Video_Export_Precheck_IgnoreInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Precheck_IgnoreInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ignorer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ignorieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ignorare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Игнорировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ignorar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("忽略")
	if (locale === "ja") return /** @type {LocalizedString} */ ("無視する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनदेखा करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ignorar")
	return /** @type {LocalizedString} */ ("Ignore")
});